import { ContentState, convertToRaw, EditorState } from "draft-js";
import htmlToDraft from "html-to-draftjs";
import draftToHtml from "draftjs-to-html";

const htmlToDraftBlocks = (content) => {
  if (!!!htmlToDraft) return;

  const blocksFromHtml = htmlToDraft(content || "");
  const { contentBlocks, entityMap } = blocksFromHtml;
  const contentState = ContentState.createFromBlockArray(
    contentBlocks,
    entityMap
  );
  const editorState = EditorState.createWithContent(contentState);
  return editorState;
};

const isEmptyContent = (html, onlyParagraphs) => {
  const normalized = html.replace(/\s+/g, "");

  return (
    normalized === "<p></p>" ||
    (!onlyParagraphs &&
      (normalized === "<ul><li></li></ul>" ||
        normalized === "<ol><li></li></ol>"))
  );
};

const convertToHTML = (editorState, onlyParagraphs) => {
  if (!!!draftToHtml || !!!editorState) return;

  const content = editorState.getCurrentContent();
  const raw = convertToRaw(content);
  const html = draftToHtml(raw);

  if (isEmptyContent(html, onlyParagraphs)) {
    return "";
  }

  return html;
};

const getPlainText = (html, maxLength = 24) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html || "";

  const textWalker = document.createTreeWalker(tempDiv, NodeFilter.SHOW_TEXT, {
    acceptNode: (node) => {
      if (
        !node.textContent.trim() ||
        ["SCRIPT", "STYLE"].includes(node.parentElement?.tagName)
      ) {
        return NodeFilter.FILTER_REJECT;
      }
      return NodeFilter.FILTER_ACCEPT;
    },
  });

  const firstTextNode = textWalker.nextNode();
  const text = firstTextNode ? firstTextNode.textContent.trim() : "";

  const hasMoreContent =
    !!textWalker.nextNode() ||
    tempDiv.querySelectorAll("p, br, ul, ol, div, table, blockquote").length >
      1;

  let result = text;
  if (text.length > maxLength) {
    result = text.substring(0, maxLength) + "...";
  } else if (hasMoreContent && text.length > 0) {
    result = text + "...";
  }

  return result;
};

export { htmlToDraftBlocks, convertToHTML, getPlainText };
